import React, { Component } from "react";
import TableDatabase from "../tabledatabase.component";
import Searchbar from '../searchbar/searchbar.component'
import Grid from '@material-ui/core/Grid';
import MenuItem from "@material-ui/core/MenuItem";
import { Box, InputBase } from '@material-ui/core';
import { getAllEvents, addEvent, addImage, deleteSingleEvent } from "../api";
import DropdownDatabase from "../dropdown-makestyle/dropdown.styles";
import swal from '@sweetalert/with-react';
import './alertbutton.styles.css'

class TableDirectory extends Component {

    constructor() {
        super()

        //states are created to handle components and data

        this.state = {
            events: [],
            searchField: '',
            placeholder: '',
            eventType: "",
            images: [],
            from: '',
            to: '',
            filteredData: '',
            errorFrom: '',
            errorTo: '',
            
        }

        this.searchField = '';
        this.eventType = '';
        this.to = '';
        this.from = '';
    }

    //This func is for the searchbar
    handleChange = event => {
        this.setState({ value: event.target.value });
    };

    // handle generic filter 
    handleFilterGenerico = () => {
        const result = this.state.events.filter(item => {
            let filter = true;

            // if(this.filter.searchField.length) 
            if (this.searchField.length) {
                filter = filter && item.eventDescription.toLowerCase().includes(this.searchField.toLowerCase()) ||
                    item.eventType.toLowerCase().includes(this.searchField.toLowerCase()) ||
                    item.eventDate.toString().includes(this.searchField.toLowerCase()) ||
                    item.place.toLowerCase().includes(this.searchField.toLowerCase())
            }

            if ('' !== this.eventType) {
                filter = filter && item.eventType.toLowerCase().includes(this.eventType.toLowerCase())
            }

            if ('' !== this.from || '' !== this.to) {
                const checkDate =
                    (this.from.length && 4 === this.from.length && !this.to.length) ||
                    (this.from.length && this.from.length === 4 && this.to.length &&
                        this.to.length === 4 &&
                        parseInt(this.to) >= parseInt(this.from)) ||
                    (!this.from.length && this.to.length === 4);

                if (checkDate) {
                    if (!this.to.length) {
                        filter = filter && parseInt(item.eventDate) >= parseInt(this.from);
                    } else if (!this.from.length && this.to.length) {
                        filter = filter && parseInt(item.eventDate) <= parseInt(this.to);
                    } else {
                        filter = filter && parseInt(item.eventDate) >= parseInt(this.from) && parseInt(item.eventDate) <= parseInt(this.to);
                    }
                }
            }

            return filter;
        });

        this.setState({ filteredData: result })
    }


    //This is for the dropdown category, when we click, it sets the state.
    handleChangeCategory = event => {
        this.eventType = event.target.value;
        this.setState({ eventType: this.eventType });
        this.handleFilterGenerico();
    };

    //Get Unique name for the category.
    getUnique(arr, comp) {
        const unique = arr
            //store the comparison values in the array
            .map(e => e[comp])
            // store the keys of an unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)
            // Delete the dead keys & store unique objects
            .filter(e => arr[e])
            .map(e => arr[e]);
        return unique;
    }


    //test to save data Events
    saveData = async (event) => {
        const newEvent = [event];
       // console.log(newEvent)
        const response = await addEvent(newEvent)
        this.setState(state => ({
            events: [...state.events, ...response],
        }))

    }

    testSaveImages = async () => {
        const newImage = [
            {
                "id": 10,
                "dimensions": "cosa",
                "anno": 1900,
                "lngStampa": 15.12453,
                "record": "Ea-Sa-1688",
                "nota": "Qualcosa",
                "documento": "Descriptive",
                "link": "http://access.bl.uk/item/viewer/ark:/81055/vdc_100026995072.0x000001",
                "shortTitle": "Ao",
                "latStampa": 13,
                "medium": "qual",
                "descrizione": "che",
                "printer": "Carlo Porsile",
                "luogoStampa": "Naples",
                "autore": "Filippo Neri",
                "titolo": "Narrazione de' prodigi operati del glorioso S. Filippo Neri. Nella persona dell'Eminent. Sig. Cardinale Orsini Arcivescovo di Benenvento. In occasione che rimase sotto le rouine delle sue stanze nel Tremuoto che distrusse quella Città à 5 di Giugno 1688. In Napoli MDCLXXXVIII. Presso Novello de Bonis Stampatore Arcivescovale, Con Licenza de' Superiori"
            }
        ]
        const response = await addImage(newImage)
      //  console.log(response)
        this.setState(state => ({
            images: [...state.images, ...response],
        }))
    }


    //test to save Images
    saveDataImages = async (image) => {
        const newImage = [image];
       // console.log(newImage)

        const response = await addImage(newImage)
        this.setState(state => ({
            images: [...state.images, ...response],
        }))

    }

    handleEventsDate = (e, dataType) => {
        const val = e.target.value;
       // console.log(this.state.to)
        this.state.events.filter(event => {
            // console.log(event.anno)
        })
        if (val.length <= 4 && /^(\s*|\d+)$/.test(val)) {

        }

    }



    // restituisce i dati filtrati

    dataToRender = () => {
        if (
            this.state.from.length ||
            this.state.to.length ||
            this.state.eventType.length ||
            this.state.searchField.length) {
            return this.state.filteredData;
        } else {
            return this.state.events;
        }
    }

    deleteSingleEvent = async recordId => {
        const resp = await deleteSingleEvent(recordId);

        if (resp) {
            const updatedEvents = this.state.events.filter(el => el.id !== recordId)
            this.setState({ events: updatedEvents });
        }
    }

    //http://localhost:8080/api/eventi
    //http://discompose.unina.it/api/eventi

    //We get the api call for the events /////
    async componentDidMount() {
        // const dataImage = await getAllImages()
        // this.setState({images: dataImage})
        //console.log(dataImage)

        const data = await getAllEvents()
        this.setState({ events: data })
    }

    handleSearchField = e => {
        this.searchField = e.target.value;
        if (this.searchField === "$RGGFMFRUS941W") {
            swal({
                content:
                    <div style={{ fontFamily: 'Montserrat', fontSize: '14px', paddingTop: '20px' }}>
                        <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '5px' }}>INFO</h1>
                        <hr style={{ border: '1px solid #DC251A', marginTop: '-5px', marginBottom: '25px' }}></hr>
                        <ul style={{ listStyleType: 'none', textAlign: 'left', marginLeft: '-39px' }}>
                            <li>-The Pier Program-</li>
                            <li>Designed and Developed with love ❤️</li>
                            <li>at the Apple Developer Academy</li>
                            <br></br>
                            <li style={{ fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: '14px' }} >This alert will be automatically destroyed in 30 secs </li>
                        </ul>

                    </div>,
                button: {
                    text: "DESTROY",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },
                timer: 30000,
            })
        }
        this.setState({ searchField: this.searchField });
        this.handleFilterGenerico();
    }


    handleFromDate = e => {
        this.from = e.target.value;
        this.setState({ from: this.from });
        this.handleFilterGenerico()
        if (this.from.length === 4 && this.from < 1500 || this.from.length === 4 && this.from > 1800) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>Please, the date must be in the range of 1500 - 1800</p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }

        if (this.from.length > 4) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>You can't type more than 4 numbers.</p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }
        // To check if there is a string
        (this.from.match(/[^0-9]/)) ? this.setState({errorFrom : "The date can't contain a string"}) : this.setState({errorFrom: ''})
    }

    handleToDate = e => {
        this.to = e.target.value;
        this.setState({ to: this.to });
        this.handleFilterGenerico();
        if (this.to.length === 4 && this.to < 1500 || this.to.length === 4 && this.to > 1800) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>Please, the date must be respectively  in the range of 1500 - 1800</p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })

        }

        if (this.from > this.to && this.to.length === 4) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>The research is failed. Please, the date must be respectively in the range of 1500 - 1800</p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }

        if (this.from === 4  &&  (this.to.length === 4)  < (this.from)) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>The research is failed, the first value can't be minor than the second one. Please, type always a value in the range of 1500 - 1800 </p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }

        if (this.from === "1800" && this.to.length === 4 < this.from)  {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '14px' }}>The research is failed. The first value can't be greater than the second one. The date must be in the range of 1500 - 1800. </p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }
        if (this.to.length > 4) {
            swal({
                content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
                    <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ERROR</h1>
                    <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
                    <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>You can't type more than 4 numbers.</p>
                </div>,
                button: {
                    text: "OK",
                    value: true,
                    visible: true,
                    className: "stylebutton",
                    closeModal: true,
                },

            })
        }
        // to check if there is a string
         (this.to.match(/[^0-9]/)) ? this.setState({errorTo : "The date can't contain a string"}) : this.setState({errorTo: ""})
    }

    handleDeleteEvent = async (record_id) => {


    }

    render() {
        const { classes } = this.props;
        const uniqueCategory = this.getUnique(this.state.events, "eventType");
        const eventi = this.state.events;
        const { events, searchField, eventType } = this.state



        return (
            <div style={{ marginRight: "8%", marginLeft: "8%" }}>

                <Grid container >

                    <Grid item lg={12} >
                        <Searchbar handleChange={this.handleSearchField} searchFieldValue={this.state.searchField} />
                    </Grid>
                </Grid>
                <Grid container >
                    <Grid item lg={3} md={3} sm={12} xs={12}>
                        <p style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '200', marginBottom: '6px', marginTop: '20px' }}>FROM YEAR</p>
                        <InputBase style={{ backgroundColor: '#F0F0F0', marginTop: '-2px', height: '33px', paddingLeft: '8px', paddingTop: '5px', paddingBottom: '8px', fontFamily: 'Montserrat', fontWeight: '500', fontSize: '15px', float: 'left'  }}
                        //   type= "number"
                           placeholder="1500"
                            onChange={this.handleFromDate}
                            value={this.state.from}
                            inputProps={{ maxLength: 4 }}
                        />
                           <p style={{fontFamily: 'Montserrat', fontSize: '12px', color: '#DC251A', marginTop: '40px'}}>{this.state.errorFrom}</p>
                    </Grid>

                    <Grid item lg={3} md={3} sm={12} xs={12}>
                        <p style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '200', marginBottom: '6px', marginTop: '20px'  }}>TO YEAR</p>
                        <InputBase style={{ backgroundColor: '#F0F0F0', height: '33px', marginTop: '-2px', paddingLeft: '8px', paddingTop: '5px', paddingBottom: '8px', fontFamily: 'Montserrat', fontWeight: '500', fontSize: '15px', float: 'left' }}
                           // type= "number"
                            placeholder="1800"
                            onChange={this.handleToDate}
                            value={this.state.to}
                            inputProps={{ maxLength: 4 }}
                        />
                     <p style={{fontFamily: 'Montserrat', fontSize: '12px', color: '#DC251A', marginTop: '40px'}}>{this.state.errorTo}</p>
                    </Grid>

                    <Grid item lg={3} md={3} sm={12} xs={12}>
                        {/*DROPDOWN GETS DATA FROM THE DATABASE */}
                        <p style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '200', marginBottom: '6px', marginTop: '20px'  }}>EVENT TYPE</p>
                        <DropdownDatabase statecategoria={this.state.eventType} handlechangecategory={this.handleChangeCategory} unique={uniqueCategory.map(evento => (
                            <MenuItem style={{ fontFamily: 'Montserrat', fontWeight: '500', fontSize: '15px' }} key={evento.id} value={evento.eventType}>
                                {evento.eventType}
                            </MenuItem>
                        ))} />
                    </Grid>
                    
                   
                 
                </Grid>
                <TableDatabase
                        key={events.id}
                        anno={events.eventDate}
                        descrizioneEvento={events.eventDescription}
                        eventType={events.eventType}
                        place={events.place}
                        event={this.dataToRender()}
                        deleteSingleEvent={this.deleteSingleEvent}
                    />

            </div>
        )
    }
}

export default TableDirectory;